import { GuardedComponent } from '../components/guarded-component';
import { Dashboard } from '../features/dashboard/dashboard.page';

export const DashboardRoute = {
  index: true,
  element: (
    <GuardedComponent requiredPermissions={[]}>
      <Dashboard />
    </GuardedComponent>
  ),
};
